const replaceSubmissionFunder = function (
  { commit, dispatch },
  { id, index, value }
) {
  commit("REPLACE_SUBMISSION_FUNDER", { id, index, value });
  dispatch("validateSubmission");
};

export default replaceSubmissionFunder;
